import React, { useEffect, useState } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./CoffeeOfTheWeekPage.module.css";
import axios from "axios";

function CoffeeOfTheWeekPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("/api/pages/coffee-of-the-week")
      .then((res) => setData(res.data))
      .catch((err) => console.error("Error loading COTW:", err));
  }, []);

  const t = data?.textFields || {};
  const img = data?.imageFields || {};

  // Helper to split textarea lines into <li> items
  const renderDetails = (text) => {
    if (!text) return null;
    return text.split("\n").map((line, i) => <li key={i}>{line}</li>);
  };

  return (
    <div className={styles.cotwPage}>
      <Navbar />

      <section
        className={styles.heroSection}
        style={{ backgroundImage: `url(${img.heroBg || ""})` }}
      >
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            {t.heroTitle || "COFFEE OF THE WEEK"}
          </h1>
          <h2 className={styles.heroSubtitle}>
            {t.heroSubtitle || "What’s Coffee of the Week?"}
          </h2>
          <p className={styles.heroText}>{t.heroText}</p>
        </div>
      </section>

      <section className={styles.logoBanner}>
        {img.roasterLogo && (
          <img
            src={img.roasterLogo}
            alt="Roaster Logo"
            className={styles.logoImage}
          />
        )}
      </section>

      <div className={styles.contentContainer}>
        <div className={styles.roasterInfo}>
          {t.roasterInfo?.split("\n").map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>

        <div className={styles.storySection}>
          <h3 className={styles.storyTitle}>{t.storyTitle}</h3>
          <p className={styles.storyText}>{t.storyText}</p>
        </div>

        <div className={styles.productImageContainer}>
          {img.productImage && (
            <img
              src={img.productImage}
              alt="Product"
              className={styles.productImage}
            />
          )}
        </div>

        <p className={styles.availabilityText}>{t.availabilityText}</p>

        <div className={styles.coffeeList}>
          {[1, 2, 3, 4].map(
            (num) =>
              t[`c${num}Title`] && (
                <div key={num} className={styles.coffeeItem}>
                  <h2>{t[`c${num}Title`]}</h2>
                  <ul className={styles.coffeeDetails}>
                    {renderDetails(t[`c${num}Details`])}
                  </ul>
                </div>
              ),
          )}
        </div>

        <div className={styles.specialSection}>
          <p>{t.specialText}</p>
          <div className={styles.moreInfo}>
            For more info, check their website:
            <a href={t.websiteLink} target="_blank" rel="noopener noreferrer">
              {t.websiteLink}
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CoffeeOfTheWeekPage;
